/*
  Adds simple popover functionality to an element
  @params target (string) CSS selector for element to trigger the popover.

  Exanple markup:
    <span class="trigger">
      <span class="popover">
        Popover content goes here...
      </span>
      Click me for popover
    </span>

  Example javascript:
    new npm.Popover('.trigger');

*/
module.exports = function(selector) {


  var self = {}, 
      open = false;

  self.init = function() {

    self.$el = $(selector);
    self.$popover = self.$el.find('.content');
    bindEvents();
  };

  /* private */

  function bindEvents() {
    self.$el.on('click', toggle);
    $(window).on('click', close);
  }

  function toggle(event) {
    if (open && event.target.nodeName !== 'A') {
      // close
      open = false;
      self.$popover.removeClass('show');
    }
    else {
      // open
      open = true;
      self.$popover.addClass('show');
    }
  }

  function close(event) {
    if (self.$el[0] !== event.target && self.$el.find(event.target).length === 0) {
      open = false;
      self.$popover.removeClass('show');
    }
  }

  // dom ready
  $(self.init);

  return self;
};